import { GetSessionFilesDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

interface SessionProps {
  sessionId?: string
  trainingId?: string
  visibility?: boolean
  ids?: string[]
}
export const useSessionFiles = ({ sessionId, trainingId, visibility, ids }: SessionProps) => {
  const { loading, data } = useQuery(GetSessionFilesDocument, {
    variables: { sessionId, trainingId, visibility, ids },
  })

  return {
    loading,
    sessionFiles: data ? data.trainings.sessionFilesConnection.nodes : [], // Provide a default value
  }
}
